// last-active-page.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LastActivePageService {
  private lastActivePage: string | null = null;

  constructor() { }

  storeLastActivePage(url: string): void {
    console.log(url + 'is last page');
    localStorage.setItem('lastPageVisited' , url);
    this.lastActivePage = url;
  }

  getLastActivePage(): string | null {
    return localStorage.getItem('lastPageVisited');
  }

  clearLastActivePage(): void {
    localStorage.setItem('lastPageVisited' , null);
  }
}
